<mat-toolbar class="toolbar">
  <button class="btn-close-sidenav" mat-icon-button (click)="menuDrawer.toggle()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <div class="tittle-container">
    <img class="logo-toolbar" src="assets/img/gma_tipografia.png"/>
  </div>
</mat-toolbar>

<mat-nav-list>

  <!-- Home -->
  <smrts-item-menu [menuDrawer]="menuDrawer" url="/" text="Página inicial" icon="home"></smrts-item-menu>

  <!-- Exemplo sub menu -->
  <smrts-list-menu [menuDrawer]="menuDrawer" text="Financeiro" icon="monetization_on" expanded="true">
    <smrts-item-menu *hasPermission="permissaoVisualizarMovimentacaoCaixa" [menuDrawer]="menuDrawer" url="/movimentacao-caixa" text="Movimentação do Caixa" class="subitem"></smrts-item-menu>
    <smrts-item-menu *hasPermission="permissaoVisualizarPainelFinanceiro" [menuDrawer]="menuDrawer" url="/painel-financeiro" text="Painel Financeiro" class="subitem"></smrts-item-menu>
    <smrts-item-menu *hasPermission="permissaoEditarLancamento" [menuDrawer]="menuDrawer" url="/lote-lancamentos" text="Criar novo lote de lançamentos" class="subitem"></smrts-item-menu>
    <smrts-item-menu *hasPermission="permissaoVisualizarRelatorioCaixa" [menuDrawer]="menuDrawer" url="/relatorio-financeiro" text="Relatório Financeiro" class="subitem"></smrts-item-menu>
    <smrts-item-menu *hasPermission="permissaoVisualizarConfiguracaoCaixa" [menuDrawer]="menuDrawer" url="/configuracao-caixa" text="Configuração do Caixa" class="subitem"></smrts-item-menu>
    <smrts-item-menu *hasPermission="permissaoVisualizarRegraConciliacaoAutomatica" [menuDrawer]="menuDrawer" url="/regra-conciliacao-automatica" text="Regras de Conciliação Automática" class="subitem"></smrts-item-menu>
  </smrts-list-menu>
  
  <smrts-list-menu *hasPermission="permissoesVistoria" [menuDrawer]="menuDrawer" text="Vistoria" icon="home_work" expanded="true">
    <smrts-item-menu *hasPermission="permissaoRealizarVistoria" [menuDrawer]="menuDrawer" url="/vistoria" text="Vistorias" class="subitem"></smrts-item-menu>
    <smrts-item-menu *hasPermission="permissaoEditarRoteiroVistoria" [menuDrawer]="menuDrawer" url="/vistoria/modelos" text="Modelos de Vistoria" class="subitem"></smrts-item-menu>
  </smrts-list-menu>

  <smrts-list-menu *hasPermission="permissaoAdministrarContas" [menuDrawer]="menuDrawer" text="Usuarios" icon="group" expanded="true">
    <smrts-item-menu [menuDrawer]="menuDrawer" url="/gerenciar-perfis-usuarios" text="Gerenciar Perfis dos Usuarios" class="subitem"></smrts-item-menu>
  </smrts-list-menu>

  <smrts-menu-usuario [menuDrawer]="menuDrawer"></smrts-menu-usuario>

</mat-nav-list>